export default {"src":"/_next/static/media/img_user_explain.f6ffe49c.svg","height":189,"width":99,"blurWidth":0,"blurHeight":0};